"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollbar = void 0;
var react_1 = __importStar(require("react"));
var react_is_1 = require("react-is");
var smooth_scrollbar_1 = __importDefault(require("smooth-scrollbar"));
var overscroll_1 = __importDefault(require("smooth-scrollbar/plugins/overscroll"));
smooth_scrollbar_1.default.use(overscroll_1.default);
var SmoothScrollbarReact = react_1.forwardRef(function SmoothScrollbarReact(props, ref) {
    var container = react_1.useRef(null);
    var scrollbar = react_1.useRef(null);
    var children = props.children, className = props.className, style = props.style, onScroll = props.onScroll, restProps = __rest(props, ["children", "className", "style", "onScroll"]);
    var assignForwardRef = react_1.useCallback(function () {
        if (ref) {
            ref.current = scrollbar.current;
        }
    }, [ref]);
    react_1.useEffect(function () {
        scrollbar.current = smooth_scrollbar_1.default.init(container.current, restProps);
        var handleScroll = function (status) {
            if (typeof onScroll === 'function') {
                onScroll(status, scrollbar.current);
            }
        };
        scrollbar.current.addListener(handleScroll);
        assignForwardRef();
        return function () {
            scrollbar.current.removeListener(handleScroll);
            scrollbar.current.destroy();
            assignForwardRef();
        };
    }, []);
    react_1.useEffect(function () {
        if (scrollbar.current) {
            Object.keys(restProps).forEach(function (key) {
                if (!(key in scrollbar.current.options)) {
                    return;
                }
                if (key === 'plugins') {
                    Object.keys(restProps.plugins).forEach(function (pluginName) {
                        scrollbar.current.updatePluginOptions(pluginName, restProps.plugins[pluginName]);
                    });
                }
                else {
                    scrollbar.current.options[key] = restProps[key];
                }
            });
            scrollbar.current.update();
            assignForwardRef();
        }
    }, [restProps, assignForwardRef]);
    var count = react_1.default.Children.count(children);
    if (count === 1 && react_is_1.isElement(children)) {
        return react_1.default.cloneElement(children, {
            ref: container,
            className: (children.props.className ? children.props.className + " " : '') +
                className,
            style: __assign(__assign({}, style), children.props.style),
        });
    }
    return react_1.default.createElement('div', {
        ref: container,
        className: className,
        style: __assign(__assign({}, style), { WebkitBoxFlex: 1, msFlex: 1, MozFlex: 1, flex: 1 }),
    }, react_1.default.createElement('div', {
        className: 'scroll-content-inner',
    }, children));
});
exports.Scrollbar = SmoothScrollbarReact;
